// Helpers for rendering contribution titles in the shared-folder / contribute
// flow. Contributed items are submitted with an empty title (the owner titles
// them later after approval), so the list rows have to handle "no title"
// gracefully — mirroring the Flutter app.
//
// Two cases are treated as "no title":
//   1. Empty string (after trim).
//   2. A date-like placeholder — the backend sometimes fills an empty title
//      with the upload date/timestamp, so we hide those instead of showing a
//      raw date-time to the user.

// Date-like patterns (kept in sync with the Flutter app, contribute_upload_page.dart):
//   - YYYY-MM-DD / YYYY/MM/DD (optional time + AM/PM)
//   - MM-DD-YYYY / MM/DD/YYYY (optional time + AM/PM)
//   - bare time HH:MM[:SS] [AM/PM]
const DATE_LIKE_PATTERNS = [
  /^\d{4}[-/]\d{1,2}[-/]\d{1,2}(\s+\d{1,2}:\d{2}(:\d{2})?\s*([AaPp][Mm])?)?$/,
  /^\d{1,2}[-/]\d{1,2}[-/]\d{4}(\s+\d{1,2}:\d{2}(:\d{2})?\s*([AaPp][Mm])?)?$/,
  /^\d{1,2}:\d{2}(:\d{2})?\s*([AaPp][Mm])?$/,
];

export const isDateLikeTitle = (title) => {
  const trimmed = (title == null ? '' : String(title)).trim();
  if (!trimmed) return false;
  return DATE_LIKE_PATTERNS.some((re) => re.test(trimmed));
};

// Returns the title to display, or '' if the title should be hidden (empty or
// a date-like placeholder). When this returns '', callers should promote the
// "Type · Date" subtitle to the primary line instead of rendering a title.
export const resolveContributionTitle = (title) => {
  const trimmed = (title == null ? '' : String(title)).trim();
  if (!trimmed) return '';
  return isDateLikeTitle(trimmed) ? '' : trimmed;
};
